import { render, staticRenderFns } from "./SeoSetting.vue?vue&type=template&id=5d6f332b&scoped=true"
import script from "./SeoSetting.vue?vue&type=script&lang=js"
export * from "./SeoSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6f332b",
  null
  
)

export default component.exports